<template>
  <div class="helpCenter">
    <div class="btns">
      <el-radio-group v-model="model_type" @change="tabClick">
        <el-radio-button :label="1">基础功能</el-radio-button>
        <el-radio-button :label="2">操作说明</el-radio-button>
      </el-radio-group>
    </div>
    <div class="help-main" v-if="model_type == 1">
      <div class="item" v-for="item in video_list" :key="item.url" @click="play(item)">
        <div class="img">
          <img :src="item.url + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_800,h_600,m_fast'" alt="">
        </div>
        <div class="text"> {{item.text}} </div>
      </div>
    </div>
    <div class="help-main" v-else>
      <div class="explain">
        <a class="downloadBtn" :href="explain" download="explain.png">下载</a>
        <el-image :src="explain" :preview-src-list="srcList"></el-image>
      </div>
    </div>
    <div class="my-video" v-show="currentObj.url">
      <div class="el-icon-close" @click="close"></div>
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :options="playerOptions" />
    </div>
    <div class="mask" v-show="currentObj.url" @click="close"></div>
  </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import img1 from '../../../assets/images/teacher/explain.png'
export default {
  components: {
    videoPlayer
  },
  data() {
    return {
      model_type: 1,
      video_list: [
        { url: 'https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/001%E5%A6%82%E4%BD%95%E4%B8%8A%E4%B8%8B%E8%AF%BE.mp4', text: '如何上下课？' },
        { url: 'https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/002%E5%A6%82%E4%BD%95%E6%9F%A5%E7%9C%8B%E5%AD%A6%E7%94%9F%E6%88%90%E7%BB%A9.mp4', text: '如何查看学生成绩' },
        // { url: 'https://wlkt-repo-test.oss-cn-shanghai.aliyuncs.com/video/1/1625887532301_20210706-142842.mp4', text: '如何进行兑换审核？' },
        // { url: 'https://wlkt-repo-test.oss-cn-shanghai.aliyuncs.com/video/1/1625813618793_学前必读.mp4', text: '如何查看兑换进度？' },
      ],
      currentObj: {},
      explain: img1,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          // 类型
          src: '../../assets/image/avi.avi' // url地址
        }],
        poster: '', // 封面地址
        width: '100%',
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        },
        fullscreenToggle: true
      },
      srcList: [img1],
      backupsObj: {}
    }
  },
  methods: {
    // tab切换
    tabClick() {
      this.currentObj = {}
    },
    // 播放
    play(val) {
      this.currentObj = val
      this.backupsObj = val
      this.playerOptions.sources[0].src = val.url
    },
    // 关闭视频
    close() {
      this.currentObj = {}
      this.$refs.videoPlayer.player.pause()
    }
  },
  beforeDestroy() {
    this.$refs.videoPlayer.player.pause()
  }
}
</script>
<style lang="scss" scoped>
.helpCenter {
  width: 100%;
  height: 100%;
  position: relative;
  .btns {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    // width: 100%;
    display: flex;
    justify-content: space-between;
    .tea-btn {
      margin-bottom: 20px;
      &.el-button--primary {
        background-color: #5186c2;
        border-color: #5186c2;
      }
    }
    ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #5186c2 !important;
      border: 1px solid #5186c2;
    }
    ::v-deep .el-radio-button__inner {
      font-size: 16px;
    }
  }
  .help-main {
    position: absolute;
    top: 85px;
    left: 0;
    right: 0;
    bottom: 30px;
    border: 2px dashed #ccc;
    box-sizing: border-box;
    padding: 20px;
    .item {
      width: 24%;
      float: left;
      margin-left: 1%;
      border-radius: 10px;
      background: #fff;
      padding: 5px;
      box-shadow: 0 0 3px 1px rgba(204, 204, 204, .5);
      cursor: pointer;
      .img {
        width: 100%;
        border-radius: 10px;
        img {
          display: block;
          border-radius: 10px;
          width: 100%;
          height: 10vw;
        }
      }
      .text {
        margin-top: 10px;
        text-align: center;
        font-size: 1vw;
      }
    }
  }
  .my-video {
    width: 100%;
    height: calc(100% - 30px);
    width: 100%;
    background-color: white;
    position: relative;
    z-index: 1;
    .el-icon-close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #fff;
      color: #000;
      font-size: 30px;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 2;
      cursor: pointer;
    }
    video {
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
      width: 100% !important;
      //height: calc(100vh - 95px) !important;
      object-fit: fill; //消除留白
    }
  }
  .explain {
    width: 100%;
    height: 100%;
    overflow: auto;
    img {
      display: block;
      width: 100%;
    }
  }
  .downloadBtn {
    display: inline-block;
    width: 106px;
    height: 42px;
    font-size: 18px;
    text-align: center;
    line-height: 42px;
    border-radius: 4px;
    background-color: #5186c2;
    border-color: #5186c2;
    color: #fff;
    position: fixed;
    bottom: 4vw;
    right: 6vw;
    z-index: 1;
  }
  .video-player {
    width: 100%;
    height: 100%;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.1);
  }
}
</style>
<style lang="scss">
.helpCenter {
  .vjs-big-play-button {
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
  .video-js {
    height: 100% !important;
    padding-top: 0 !important;
  }
  video {
    object-fit: fill; //消除留白
  }
}
</style>